import { visitorHeaders } from './visitorId';

export type LikeInfo = {
  count: number;
  liked: boolean;
};

const cache = new Map<string, LikeInfo>();
const listeners = new Set<(url: string, info: LikeInfo) => void>();

function notify(url: string, info: LikeInfo): void {
  cache.set(url, info);
  for (const fn of listeners) {
    fn(url, info);
  }
}

export function onLikeChange(fn: (url: string, info: LikeInfo) => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function getLikeInfo(url: string): LikeInfo | undefined {
  return cache.get(url);
}

export function resetLikeCache(): void {
  cache.clear();
}

/** Принудительно отметить «мой лайк» (страница ♥ мои). */
export function markLiked(url: string, count = 1): void {
  notify(url, { count, liked: true });
}

export async function fetchLikeCounts(urls: string[]): Promise<void> {
  const pending = urls.filter(url => !cache.has(url));
  if (pending.length === 0) {
    return;
  }

  try {
    const r = await fetch('/api/likecounts', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', ...visitorHeaders() },
      body: JSON.stringify({ urls: pending.slice(0, 64) }),
    });
    if (!r.ok) {
      return;
    }
    const data = (await r.json()) as { items?: Record<string, LikeInfo> };
    const items = data.items ?? {};
    for (const [url, info] of Object.entries(items)) {
      notify(url, info);
    }
  } catch {
    // ignore
  }
}

export async function toggleLike(url: string): Promise<LikeInfo | null> {
  try {
    const r = await fetch('/api/like', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', ...visitorHeaders() },
      body: JSON.stringify({ url }),
    });
    if (!r.ok) {
      return null;
    }
    const data = (await r.json()) as { count?: number; liked?: boolean };
    const info: LikeInfo = {
      count: Number(data.count ?? 0),
      liked: Boolean(data.liked),
    };
    notify(url, info);
    return info;
  } catch {
    return null;
  }
}